import {
  STOCK_BUCKET_LABELS,
  type StockAdjustment,
  type StockBucket,
} from "@artisancode/api-types";

export interface AdjustmentFilters {
  query: string;
  itemType: string;
  status: string;
  bucket: string;
}

export function filterAdjustments(
  adjustments: StockAdjustment[],
  { query, itemType, status, bucket }: AdjustmentFilters,
): StockAdjustment[] {
  const q = query.toLowerCase();
  return adjustments.filter((adj) => {
    if (itemType !== "all" && adj.itemType !== itemType) return false;
    if (status !== "all" && adj.status !== status) return false;
    if (bucket !== "all" && adj.bucket !== bucket) return false;
    if (!q.trim()) return true;
    return [adj.code, adj.itemName, adj.reasonName, adj.note].some((v) =>
      (v ?? "").toLowerCase().includes(q),
    );
  });
}

export function getBucketLabel(bucket: string): string {
  return STOCK_BUCKET_LABELS[bucket as StockBucket] || bucket;
}

/** Stock value gained (+) or lost (-) by the adjustment. */
export function getAdjustmentValueImpact(adj: StockAdjustment): number {
  return adj.difference * (adj.costPerUnit || 0);
}
